import React, { useState } from 'react';

import { Gap, Gutter, Text, Title } from '@common/components';
import {
  AuthTemplateCentralizedContainer,
  AuthTemplateHelp,
  AuthTemplateLogo,
  SignInEmailFormRecordType,
} from '@identity/components';
import { useRedirectPath } from '@identity/hooks/use-redirect-path';
import Auth from 'works/legacy/lib/auth';
import { useQueryParam } from 'works/legacy/services/query-params-service';
import { SignInPageActiveAccountsList } from './_sign-in-page-active-accounts-list';
import { SignInPageUserConfirmation } from './_sign-in-page-user-confirmation';

export function SignInPage() {
  const redirectPath = useRedirectPath();
  const newSession = useQueryParam('newSession');
  const [sessionExpired] = useState(!!redirectPath && Auth.signedIn());
  const [worksAuthInfo, setWorksAuthInfo] =
    useState<SignInEmailFormRecordType | null>(null);
  const [title, setTitle] = useState<string>("Let's get to work.");

  return (
    <AuthTemplateCentralizedContainer>
      <div className="sign-in-page">
        <AuthTemplateLogo />

        <Gutter internal size="xxl" />

        <Gap size="md" justify="stretch" vertical fullWidth>
          <Title size="h1" weight="medium">
            {title}
          </Title>

          {!worksAuthInfo && sessionExpired && !newSession && (
            <Text color="coral">
              Your session has expired due to inactivity.
            </Text>
          )}

          {!worksAuthInfo && (
            <SignInPageActiveAccountsList
              sessionExpired={sessionExpired}
              newSession={newSession}
              setWorksAuthInfo={setWorksAuthInfo}
            />
          )}

          {worksAuthInfo && (
            <SignInPageUserConfirmation
              setTitle={setTitle}
              worksAuthInfo={worksAuthInfo}
            />
          )}

          <AuthTemplateHelp />
        </Gap>
      </div>
    </AuthTemplateCentralizedContainer>
  );
}
